import api, {publicApi} from 'services/api'

const BASE_URI = ''

const h = params => {
  let tmp = ''
  Object.keys(params).filter(e => params[e]).forEach((e, i) => params[e] ? tmp = tmp + `${i ? '&' : '?'}${e}=${params[e]}` : i-- && '')
  return tmp
}
// const filterDate = date => `&createdMoreThanOrEqual=${date[0].format('YYYY-MM-DD hh:mm:ss')}&createdLessThanOrEqual=${date[1].format('YYYY-MM-DD hh:mm:ss')}`

export const dataService = {
  getWebAppConfig: () =>
    publicApi.get(`${BASE_URI}/data/webAppConfig`),
}

export const usersService = {
  authEmail: data =>
    publicApi.post(`${BASE_URI}/auth/email`, data, true),
  authGoogle: data =>
    publicApi.post(`${BASE_URI}/auth/google`, data, true),
  authRefresh: data =>
    publicApi.post(`${BASE_URI}/auth/refreshToken`, data, true),
  authNewUser: data =>
    publicApi.post(`${BASE_URI}/users`, data, true),
  patchUser: (uuid, data) =>
    api.patch(`${BASE_URI}/users/${uuid}`, data, true),
  getCustomer: uuid =>
    api.get(`${BASE_URI}/customer/${uuid}`),
  getOrderGroups: (customerUuid, pagination) =>
    api.get(`${BASE_URI}/customer/${customerUuid}/orderGroups${h(pagination)}`),
  getBillingInfo: uuid =>
    api.get(`${BASE_URI}/customer/${uuid}/billingInfo`),
  patchBillingInfo: (uuid, data) =>
    api.patch(`${BASE_URI}/customer/${uuid}/billingInfo`, data, true),
  postDeliveryAddress: data =>
    api.post(`${BASE_URI}/customer/deliveryAddresses`, data, true),
  patchDeliveryAddress: (uuid, data) =>
    api.patch(`${BASE_URI}/customer/deliveryAddresses/${uuid}`, data, true),
  deleteDeliveryAddress: uuid =>
    api.delete(`${BASE_URI}/customer/deliveryAddresses/${uuid}`),
}

export const searchService = {
  prosugcat: (query, pagination) =>
    publicApi.get(`${BASE_URI}/search/prosugcat${h({query, ...pagination})}`),
  categories: () =>
    publicApi.get(`${BASE_URI}/categories`),
  categoryProducts: (alias, query, pagination) =>
    publicApi.get(`${BASE_URI}/categories/${alias}/products${h({query, ...pagination})}`),
}

export const productService = {
  detail: (ean, merchantUuid, externalId) =>
    publicApi.get(`${BASE_URI}/products/detail${h(ean ? {ean: ean} : {externalId, merchantUuid})}`)
}

export const ordersService = {
  userPrepareOrderGroupPayment: (cartUuid, data) =>
    api.post(`${BASE_URI}/orders/${cartUuid}/prepareOrderGroupPayment`, data, true),
  guestPrepareOrderGroupPayment: (cartUuid, data) =>
    publicApi.post(`${BASE_URI}/orders/${cartUuid}/prepareOrderGroupPayment`, data, true),
}

export default [dataService, usersService, searchService, productService, ordersService]
